export default {
  name: "CameraSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M19.5 17.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM29 9.17V26a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9.17c0-1.1.9-2 2-2h3.49l2.4-3.34A2 2 0 0 1 12.51 3h6.98a2 2 0 0 1 1.62.83l2.4 3.34H27a2 2 0 0 1 2 2zm-6.5 8.33c0-3.58-2.92-6.5-6.5-6.5s-6.5 2.92-6.5 6.5S12.42 24 16 24s6.5-2.92 6.5-6.5z",
  },
}
